var React = require('react');

function EllipseFill (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"7.5","cy":"7.5","r":"7","fill":"#101010","stroke":"#101010"}));
}

EllipseFill.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = EllipseFill;

EllipseFill.default = EllipseFill;
